export default __webpack_public_path__ + "static/media/start-collaborating.63a42a92.svg";